import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { PatientsComponent } from '../../app/components/ehr/patients/patients.component';
import { ProfileComponent } from '../../app/components/ehr/patients/profile/profile.component';
import { PatientsHeaderComponent } from '../../app/components/ehr/patients/patients-header/patients-header.component';
import { EpisodeOfCareComponent } from '../../app/components/ehr/patients/episode-of-care/episode-of-care.component';
import { MedicalHistorySectionComponent } from '../../app/components/ehr/patients/components/medical-history-section/medical-history-section.component';
import { AllergiesComponent } from '../../app/components/ehr/patients/components/alerts-section/allergies/allergies.component';
import { ClinicalExaminationSectionComponent } from '../../app/components/ehr/patients/components/clinical-examination-section/clinical-examination-section.component';
import { CurrentProblemsComponent } from '../../app/components/ehr/patients/components/medical-problems-section/current-problems/current-problems.component';
import { ResolvedProblemsComponent } from '../../app/components/ehr/patients/components/medical-history-section/resolved-problems/resolved-problems.component';
import { TestComponent } from '../common/test/test.component';
import { MedicalDeviceComponent } from '../../app/components/ehr/patients/components/medical-problems-section/medical-device/medical-device.component';
import { ProcedureComponent } from '../../app/components/ehr/patients/components/medical-problems-section/procedure/procedure.component';
import { EocSectionComponent } from '../../app/components/ehr/patients/components/eoc-section/eoc-section.component';
import { AlertsSectionComponent } from '../../app/components/ehr/patients/components/alerts-section/alerts-section.component';
import { MedicalProblemsSectionComponent } from '../../app/components/ehr/patients/components/medical-problems-section/medical-problems-section.component';
import { PreviewSummaryComponent } from '../../app/components/ehr/patients/preview-summary/preview-summary.component';
import { DetailedProfileComponent } from '../../app/components/ehr/patients/detailed-profile/detailed-profile.component';
import { VaccinationComponent } from '../../app/components/ehr/patients/components/medical-history-section/vaccination/vaccination.component';
import { MedicalAlertComponent } from '../../app/components/ehr/patients/components/alerts-section/medical-alert/medical-alert.component';
import { MedicalHistoryComponent } from '../../app/components/ehr/patients/components/medical-history-section/medical-history/medical-history.component';
import { PregnancySectionComponent } from '../../app/components/ehr/patients/components/pregnancy-section/pregnancy-section.component';
import { PregnancyHistoryComponent } from '../../app/components/ehr/patients/components/pregnancy-section/pregnancy-history/pregnancy-history.component';
import { PregnancyOutcomeComponent } from '../../app/components/ehr/patients/components/pregnancy-section/pregnancy-outcome/pregnancy-outcome.component';
import { PregnancyStatusComponent } from '../../app/components/ehr/patients/components/pregnancy-section/pregnancy-status/pregnancy-status.component';
import { ImagingSectionComponent } from '../../app/components/ehr/patients/components/imaging-section/imaging-section.component';
import { ImagingFilesAddComponent } from '../../app/components/ehr/patients/components/imaging-section/imaging-files/imaging-files-add/imaging-files-add.component';
import { LaboratorySectionComponent } from '../../app/components/ehr/patients/components/laboratory-section/laboratory-section.component';
import { LaboratoryFileAddComponent } from '../../app/components/ehr/patients/components/laboratory-section/laboratory-file/laboratory-file-add/laboratory-file-add.component';
import { SupportingDocumentsAddComponent } from '../../app/components/ehr/patients/components/inital-assessment-amen-section/supporting-documents/supporting-documents-add/supporting-documents-add.component';
import { SocialHistorySectionComponent } from '../../app/components/ehr/patients/components/social-history-section/social-history-section.component';
import { SocialHistoryComponent } from '../../app/components/ehr/patients/components/social-history-section/social-history/social-history.component';
import { SocialHistoryQuestonaireComponent } from '../../app/components/ehr/patients/components/inital-assessment-amen-section/social-history-questonaire/social-history-questonaire.component';
import { DynamicQuestionnaireComponent } from '../../app/components/ehr/patients/components/inital-assessment-amen-section/dynamic-questionnaire/dynamic-questionnaire.component';
import { DynamicQuestionsComponent } from '../../app/components/ehr/patients/components/inital-assessment-amen-section/dynamic-questionnaire/dynamic-questions/dynamic-questions.component';
import { HealthCarePlanSectionComponent } from '../../app/components/ehr/patients/components/health-care-plan-section/health-care-plan-section.component';
import { CarePlanComponent } from '../../app/components/ehr/patients/components/health-care-plan-section/care-plan/care-plan.component';
import { MedicationSummarySectionComponent } from '../../app/components/ehr/patients/components/medication-summary-section/medication-summary-section.component';
import { MedicationAddComponent } from '../../app/components/ehr/patients/components/medication-summary-section/medication-add/medication-add.component';
import { CurrentMedicationComponent } from '../../app/components/ehr/patients/components/medication-summary-section/current-medication/current-medication.component';
import { PastMedicationComponent } from '../../app/components/ehr/patients/components/medication-summary-section/past-medication/past-medication.component';
import { TravelHistorySectionComponent } from '../../app/components/ehr/patients/components/travel-history-section/travel-history-section.component';
import { TravelHistoryComponent } from '../../app/components/ehr/patients/components/travel-history-section/travel-history/travel-history.component';
import { MedicationExpandComponent } from '../../app/components/ehr/patients/components/medication-summary-section/medication-expand/medication-expand.component';
import { VitalSignsComponent } from '../../app/components/ehr/patients/components/daily-monitoring-section/vital-signs/vital-signs.component';
import { DailyMonitoringSectionComponent } from '../../app/components/ehr/patients/components/daily-monitoring-section/daily-monitoring-section.component';
import { VitalSignsChartComponent } from '../../app/components/ehr/patients/components/daily-monitoring-section/vital-signs/vital-signs-chart/vital-signs-chart.component';
import { ArterialBloodGasComponent } from '../../app/components/ehr/patients/components/daily-monitoring-section/arterial-blood-gas/arterial-blood-gas.component';
import { GlasgowComponent } from '../../app/components/ehr/patients/components/daily-monitoring-section/glasgow/glasgow.component';
import { TracheostomySectionComponent } from '../../app/components/ehr/patients/components/tracheostomy-section/tracheostomy-section.component';
import { CtParametersComponent } from '../../app/components/ehr/patients/components/tracheostomy-section/ct-parameters/ct-parameters.component';
import { TubeCharacteristicsComponent } from '../../app/components/ehr/patients/components/tracheostomy-section/tube-characteristics/tube-characteristics.component';
import { EtiologySectionComponent } from '../../app/components/ehr/patients/components/etiology-section/etiology-section.component';
import { EtiologyComponent } from '../../app/components/ehr/patients/components/etiology-section/etiology/etiology.component';
import { ComorbiditySectionComponent } from '../../app/components/ehr/patients/components/comorbidity-section/comorbidity-section.component';
import { PreciousAiComponent } from '../../app/components/ehr/patients/components/precious-ai/precious-ai.component';
import { AssessmentSectionComponent } from '../../app/components/ehr/patients/components/precious-ai/assessment-section/assessment-section.component';
import { ComplicationSectionComponent } from '../../app/components/ehr/patients/components/complication-section/complication-section.component';
import { ComplicationComponent } from '../../app/components/ehr/patients/components/complication-section/complication/complication.component';
import { CapnographySectionComponent } from '../../app/components/ehr/patients/components/capnography-section/capnography-section.component';
import { CapnographyComponent } from '../../app/components/ehr/patients/components/capnography-section/capnography/capnography.component';
import { ComorbidityComponent } from '../../app/components/ehr/patients/components/comorbidity-section/comorbidity/comorbidity.component';
import { PatientCharacteristicsComponent } from '../../app/components/ehr/patients/components/patient-characteristics/patient-characteristics.component';
import { LaboratoryResultSectionComponent } from '../../app/components/ehr/patients/components/laboratory-section/laboratory-result-section/laboratory-result-section.component';
import { HysteroscopySectionComponent } from '../../app/components/ehr/patients/components/hysteroscopy-section/hysteroscopy-section.component';
import { HysteroscopyExaminationComponent } from '../../app/components/ehr/patients/components/hysteroscopy-section/hysteroscopy-examination/hysteroscopy-examination.component';
import { HysteroscopyFileAddComponent } from '../../app/components/ehr/patients/components/hysteroscopy-section/hysteroscopy-file/hysteroscopy-file-add/hysteroscopy-file-add.component';
import { HysteroscopyStartExaminationComponent } from '../../app/components/ehr/patients/components/hysteroscopy-section/hysteroscopy-start-examination/hysteroscopy-start-examination.component';
import { PatientsGocComponent } from '../components/ehr/patients-goc/patients-goc.component';
import { CognitiveAssessmentSectionComponent } from '../../app/components/ehr/patients/components/cognitive-assessment-section/cognitive-assessment-section.component';
import { InitialAssessmentAmenSectionComponent } from '../../app/components/ehr/patients/components/inital-assessment-amen-section/initial-assessment-amen-section.component';
import { EmergencyContactsComponent } from '../components/ehr/register-patient/emergency-contacts/emergency-contacts.component';
import { MedicalInfoComponent } from '../components/ehr/register-patient/medical-info/medical-info.component';
import { RegistrationExternalDoctorsComponent } from '../components/ehr/register-patient/medical-info/registration-external-doctors/registration-external-doctors.component';
import { SomatometricsSectionComponent } from '../../app/components/ehr/patients/components/somatometrics-section/somatometrics-section.component';
import { WeightComponent } from '../../app/components/ehr/patients/components/somatometrics-section/weight/weight.component';
import { NeckComponent } from '../../app/components/ehr/patients/components/somatometrics-section/neck/neck.component';
import { SelfReportSectionComponent } from '../components/ehr/patients/components/self-report-section/self-report-section.component';
import { SelfReportComponent } from '../components/ehr/patients/components/self-report-section/self-report/self-report.component';
import { BodyHighlighterComponent } from '../components/ehr/patients/components/self-report-section/self-report/body-highlighter/body-highlighter.component';
import { SmartHealthLinksComponent } from '../components/smart-health-links/smart-health-links.component';
import { ShlPatientSummaryComponent } from '../components/smart-health-links/shl-patient-summary/shl-patient-summary.component';
import { NewresetComponent } from '../components/newreset/newreset.component';
import { NewloginComponent } from '../components/newlogin/newlogin.component';
import { NewforgotComponent } from '../components/newforgot/newforgot.component';
import { ForgotUsernameComponent } from '../components/forgot-username/forgot-username.component';
import { RegisterPatientComponent } from '../components/ehr/register-patient/register-patient.component';
import { InsuranceComponent } from '../components/ehr/register-patient/insurance/insurance.component';
import { LoginComponent } from '../components/ehr/login/login.component';
import { LogoutComponent } from '../components/ehr/logout/logout.component';
import { EhrComponent } from '../components/ehr/ehr.component';
import { HeaderComponent } from '../components/ehr/header/header.component';
import { InPatientsComponent } from '../components/ehr/in-patients/in-patients.component';
import { PersonalInfoComponent } from '../components/ehr/register-patient/personal-info/personal-info.component';
import { IdentifiersComponent } from '../components/ehr/register-patient/identifiers/identifiers.component';
import { AddressComponent } from '../components/ehr/register-patient/address/address.component';
import { NotFoundComponent } from '../components/ehr/not-found/not-found.component';
import { AssignBedComponent } from '../components/ehr/in-patients/assign-bed/assign-bed.component';
import { DischargeBedComponent } from '../components/ehr/in-patients/discharge-bed/discharge-bed.component';
import { MoveBedComponent } from '../components/ehr/in-patients/move-bed/move-bed.component';
import { SelectVisitComponent } from '../components/ehr/in-patients/select-visit/select-visit.component';
import { GlucoseComponent } from '../components/ehr/patients/components/daily-monitoring-section/glucose/glucose.component';
import { NutritionIntakeComponent } from '../components/ehr/patients/components/daily-monitoring-section/nutrition-intake/nutrition-intake.component';
import { IpsSectionComponent } from '../components/ehr/patients/components/ips-section/ips-section.component';
import { IpsViewComponent } from '../components/ehr/patients/components/ips-section/ips-view/ips-view.component';
import { DietaryHabitsComponent } from '../components/ehr/patients/components/social-history-section/dietary-habits/dietary-habits.component';
import { StandaloneModule } from './standalone.module';
import { AdmissionsModule } from './admission.module';
import { FastProtocolMediterraneanQuestionnaireComponent } from '../components/ehr/patients/components/inital-assessment-amen-section/fast-protocol-mediterranean-questionnaire/fast-protocol-mediterranean-questionnaire.component';
import { FastProtocolMediterraneanQuestionsComponent } from '../components/ehr/patients/components/inital-assessment-amen-section/fast-protocol-mediterranean-questionnaire/fast-protocol-mediterranean-questions/fast-protocol-mediterranean-questions.component';
import { StrokeScoreMediterraneanQuestionnaireComponent } from '../components/ehr/patients/components/inital-assessment-amen-section/stroke-score-mediterranean-questionnaire/stroke-score-mediterranean-questionnaire.component';
import { StrokeScoreMediterraneanQuestionsComponent } from '../components/ehr/patients/components/inital-assessment-amen-section/stroke-score-mediterranean-questionnaire/stroke-score-mediterranean-questions/stroke-score-mediterranean-questions.component';
import { CarePlanFileAddComponent } from '../components/ehr/patients/components/health-care-plan-section/care-plan-file/care-plan-file-add/care-plan-file-add.component';
import { PermissionModule } from './permission.module';

@NgModule({
  declarations: [
    PatientsComponent,
    ProfileComponent,
    PatientsHeaderComponent,
    EpisodeOfCareComponent,
    MedicalHistorySectionComponent,
    AllergiesComponent,
    ClinicalExaminationSectionComponent,
    CurrentProblemsComponent,
    ResolvedProblemsComponent,
    TestComponent,
    MedicalDeviceComponent,
    ProcedureComponent,
    EocSectionComponent,
    AlertsSectionComponent,
    MedicalProblemsSectionComponent,
    PreviewSummaryComponent,
    DetailedProfileComponent,
    VaccinationComponent,
    MedicalAlertComponent,
    MedicalHistoryComponent,
    PregnancySectionComponent,
    PregnancyHistoryComponent,
    PregnancyOutcomeComponent,
    PregnancyStatusComponent,
    ImagingSectionComponent,
    ImagingFilesAddComponent,
    LaboratorySectionComponent,
    LaboratoryFileAddComponent,
    SupportingDocumentsAddComponent,
    SocialHistorySectionComponent,
    SocialHistoryComponent,
    SocialHistoryQuestonaireComponent,
    DynamicQuestionnaireComponent,
    DynamicQuestionsComponent,
    FastProtocolMediterraneanQuestionnaireComponent,
    FastProtocolMediterraneanQuestionsComponent,
    StrokeScoreMediterraneanQuestionnaireComponent,
    StrokeScoreMediterraneanQuestionsComponent,
    HealthCarePlanSectionComponent,
    CarePlanComponent,
    CarePlanFileAddComponent,
    MedicationSummarySectionComponent,
    MedicationAddComponent,
    CurrentMedicationComponent,
    PastMedicationComponent,
    TravelHistorySectionComponent,
    TravelHistoryComponent,
    MedicationExpandComponent,
    VitalSignsComponent,
    DailyMonitoringSectionComponent,
    VitalSignsChartComponent,
    ArterialBloodGasComponent,
    GlasgowComponent,
    TracheostomySectionComponent,
    CtParametersComponent,
    TubeCharacteristicsComponent,
    EtiologySectionComponent,
    EtiologyComponent,
    ComorbiditySectionComponent,
    PreciousAiComponent,
    AssessmentSectionComponent,
    ComplicationSectionComponent,
    ComplicationComponent,
    CapnographySectionComponent,
    CapnographyComponent,
    ComorbidityComponent,
    PatientCharacteristicsComponent,
    LaboratoryResultSectionComponent,
    HysteroscopySectionComponent,
    HysteroscopyExaminationComponent,
    HysteroscopyFileAddComponent,
    HysteroscopyStartExaminationComponent,
    PatientsGocComponent,
    CognitiveAssessmentSectionComponent,
    InitialAssessmentAmenSectionComponent,
    EmergencyContactsComponent,
    MedicalInfoComponent,
    RegistrationExternalDoctorsComponent,
    SomatometricsSectionComponent,
    WeightComponent,
    NeckComponent,
    SelfReportSectionComponent,
    SelfReportComponent,
    BodyHighlighterComponent,
    SmartHealthLinksComponent,
    ShlPatientSummaryComponent,
    NewresetComponent,
    NewloginComponent,
    NewforgotComponent,
    ForgotUsernameComponent,
    RegisterPatientComponent,
    InsuranceComponent,
    LoginComponent,
    LogoutComponent,
    EhrComponent,
    HeaderComponent,
    InPatientsComponent,
    PersonalInfoComponent,
    IdentifiersComponent,
    AddressComponent,
    NotFoundComponent,
    AssignBedComponent,
    DischargeBedComponent,
    MoveBedComponent,
    SelectVisitComponent,
    GlucoseComponent,
    NutritionIntakeComponent,
    IpsSectionComponent,
    IpsViewComponent,
    DietaryHabitsComponent,
  ],
  imports: [SharedModule, StandaloneModule, AdmissionsModule, PermissionModule],
  exports: [
    PatientsComponent,
    ProfileComponent,
    PatientsHeaderComponent,
    EpisodeOfCareComponent,
    MedicalHistorySectionComponent,
    AllergiesComponent,
    ClinicalExaminationSectionComponent,
    CurrentProblemsComponent,
    ResolvedProblemsComponent,
    TestComponent,
    MedicalDeviceComponent,
    ProcedureComponent,
    EocSectionComponent,
    AlertsSectionComponent,
    MedicalProblemsSectionComponent,
    PreviewSummaryComponent,
    DetailedProfileComponent,
    VaccinationComponent,
    MedicalAlertComponent,
    MedicalHistoryComponent,
    PregnancySectionComponent,
    PregnancyHistoryComponent,
    PregnancyOutcomeComponent,
    PregnancyStatusComponent,
    ImagingSectionComponent,
    ImagingFilesAddComponent,
    LaboratorySectionComponent,
    LaboratoryFileAddComponent,
    SupportingDocumentsAddComponent,
    SocialHistorySectionComponent,
    SocialHistoryComponent,
    SocialHistoryQuestonaireComponent,
    DynamicQuestionnaireComponent,
    DynamicQuestionsComponent,
    FastProtocolMediterraneanQuestionnaireComponent,
    FastProtocolMediterraneanQuestionsComponent,
    StrokeScoreMediterraneanQuestionnaireComponent,
    StrokeScoreMediterraneanQuestionsComponent,
    HealthCarePlanSectionComponent,
    CarePlanComponent,
    CarePlanFileAddComponent,
    MedicationSummarySectionComponent,
    MedicationAddComponent,
    CurrentMedicationComponent,
    PastMedicationComponent,
    TravelHistorySectionComponent,
    TravelHistoryComponent,
    MedicationExpandComponent,
    VitalSignsComponent,
    DailyMonitoringSectionComponent,
    VitalSignsChartComponent,
    ArterialBloodGasComponent,
    GlasgowComponent,
    TracheostomySectionComponent,
    CtParametersComponent,
    TubeCharacteristicsComponent,
    EtiologySectionComponent,
    EtiologyComponent,
    ComorbiditySectionComponent,
    PreciousAiComponent,
    AssessmentSectionComponent,
    ComplicationSectionComponent,
    ComplicationComponent,
    CapnographySectionComponent,
    CapnographyComponent,
    ComorbidityComponent,
    PatientCharacteristicsComponent,
    LaboratoryResultSectionComponent,
    HysteroscopySectionComponent,
    HysteroscopyExaminationComponent,
    HysteroscopyFileAddComponent,
    HysteroscopyStartExaminationComponent,
    PatientsGocComponent,
    CognitiveAssessmentSectionComponent,
    InitialAssessmentAmenSectionComponent,
    EmergencyContactsComponent,
    MedicalInfoComponent,
    RegistrationExternalDoctorsComponent,
    SomatometricsSectionComponent,
    WeightComponent,
    NeckComponent,
    SelfReportSectionComponent,
    SelfReportComponent,
    BodyHighlighterComponent,
    SmartHealthLinksComponent,
    ShlPatientSummaryComponent,
    NewresetComponent,
    NewloginComponent,
    NewforgotComponent,
    ForgotUsernameComponent,
    RegisterPatientComponent,
    InsuranceComponent,
    LoginComponent,
    LogoutComponent,
    EhrComponent,
    HeaderComponent,
    InPatientsComponent,
    PersonalInfoComponent,
    IdentifiersComponent,
    AddressComponent,
    NotFoundComponent,
    AssignBedComponent,
    DischargeBedComponent,
    MoveBedComponent,
    SelectVisitComponent,
    GlucoseComponent,
    NutritionIntakeComponent,
    IpsSectionComponent,
    IpsViewComponent,
    DietaryHabitsComponent,
  ],
})
export class PatientsModule {}
